<template>
  <div>
    <sidenav
      :is-sidebar-active.sync="sidebar"
      :is-add="isAdd"
      :item-edit="selected"
      :profile-id="profileId"
      :profile-options="profileOptions"
      :alarm-type-options="alarmTypeOptions"
      @saved="refresh"
    />
    <b-row class="pt-2 pb-1 align-items-center"
      ><b-col class="d-flex align-items-center pl-3"
        ><b-button
          variant="outline-secondary"
          size="sm"
          class="rounded-circle p-25"
          @click="goBack"
        >
          <feather-icon icon="ArrowLeftIcon" size="16" />
        </b-button>
        <span class="ml-1 text-capitalize text-dark cursor-pointer" @click="goBack">{{
          $t("actions.go_back")
        }}</span></b-col
      ><b-col class="text-right"><strong>{{ profileName }}</strong></b-col
    ></b-row>
    <b-card class="mx-2 mt-1" no-body>
      <div class="m-2">
        <b-row
          ><b-col md="6" class="d-flex align-items-center"
            ><label>{{ $t("table.show") }}</label
            ><v-select
              v-model="perPage"
              :options="[10, 25, 50, 100]"
              :clearable="false"
              class="per-page-selector mx-50"
            /><label>{{ $t("table.entries") }}</label></b-col
          >
          <b-col md="6" class="d-flex justify-content-end"
            ><b-form-input
              v-model="search"
              :placeholder="$t('table.search')"
              class="mr-1"
            /><b-button
              v-if="$can('create', 'HanwhaAlarmRule')"
              variant="primary"
              @click="openAdd"
              >{{ `${$t("actions.add")} ${$tc("hanwha_alarm_rule.title", 1)}` }}</b-button
            ></b-col
          ></b-row
        >
      </div>
      <b-table
        ref="table"
        :items="fetchItems"
        :fields="fields"
        responsive
        show-empty
        :empty-text="$t('no_record_found')"
      >
        <template #head()="data">{{ $tc(data.label, 1) }}</template>
        <template #cell(channel)="data">{{
          data.value || $t("hanwha_alarm_rule.any_channel")
        }}</template>
        <template #cell(enabled)="data"
          ><b-badge :variant="data.value ? 'success' : 'secondary'">{{
            data.value ? $t("yes") : $t("no")
          }}</b-badge></template
        >
        <template #cell(actions)="data"
          ><b-dropdown variant="link" no-caret
            ><template #button-content><feather-icon icon="MoreVerticalIcon" /></template>
            <b-dropdown-item
              v-if="$can('update', 'HanwhaAlarmRule')"
              @click="openEdit(data.item)"
              ><feather-icon icon="EditIcon" /> {{ $t("actions.edit") }}</b-dropdown-item
            >
            <b-dropdown-item
              v-if="$can('delete', 'HanwhaAlarmRule')"
              @click="remove(data.item)"
              ><feather-icon icon="TrashIcon" />
              {{ $t("actions.delete") }}</b-dropdown-item
            ></b-dropdown
          ></template
        >
      </b-table>
      <div class="mx-2 mb-2">
        <Pagination
          :total-list="total"
          :current-page="page"
          :per-page="perPage"
          @updatePagination="page = $event"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BTable,
  BButton,
  BFormInput,
  BDropdown,
  BDropdownItem,
  BBadge,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { debounce } from "lodash";
import store from "@/store";
import Pagination from "@/components/Pagination.vue";
import Sidenav from "./Sidenav.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BTable,
    BButton,
    BFormInput,
    BDropdown,
    BDropdownItem,
    BBadge,
    vSelect,
    Pagination,
    Sidenav,
  },
  data() {
    return {
      sidebar: false,
      isAdd: true,
      selected: {},
      perPage: 10,
      page: 1,
      total: 0,
      search: "",
      fields: [
        { key: "actions", label: "actions.name" },
        { key: "type_log", label: "hanwha_alarm_rule.type_log" },
        { key: "event_type", label: "hanwha_alarm_rule.event_type" },
        { key: "recovery_event_type", label: "hanwha_alarm_rule.recovery_event_type" },
        { key: "channel", label: "hanwha_alarm_rule.channel" },
        { key: "alarm_type.description", label: "hanwha_alarm_rule.alarm_type" },
        { key: "target", label: "hanwha_alarm_rule.target" },
        { key: "delay_seconds", label: "hanwha_alarm_rule.delay_seconds" },
        { key: "priority", label: "hanwha_alarm_rule.priority" },
        { key: "enabled", label: "hanwha_alarm_rule.enabled" },
      ],
    };
  },
  computed: {
    profileId() {
      return Number(this.$route.params.profileId);
    },
    profileName() {
      const profile = store.getters["hanwha_alarm_profiles/getItems"].find(
        item => Number(item.id) === this.profileId
      );
      return profile?.name || this.$route.query.profileName || "";
    },
    profileOptions() {
      return store.getters["hanwha_alarm_profiles/getSelectedItems"].filter(
        item => Number(item.value) === this.profileId
      );
    },
    alarmTypeOptions() {
      return store.getters["type_alarm/getSelectedItems"];
    },
  },
  watch: {
    page() {
      this.refresh();
    },
    perPage() {
      this.page = 1;
      this.refresh();
    },
    search: debounce(function () {
      this.page = 1;
      this.refresh();
    }, 400),
  },
  created() {
    store.dispatch("hanwha_alarm_profiles/getAll", { max: 1000 });
    store.dispatch("type_alarm/getAll", { max: 1000 });
  },
  methods: {
    goBack() {
      this.$router.push({ name: "hanwha_alarm_profiles" });
    },
    fetchItems(ctx, done) {
      store
        .dispatch("hanwha_alarm_rules/getAll", {
          max: this.perPage,
          "page[n]": this.page,
          q: this.search,
          id_hanwha_alarm_profile: this.profileId,
        })
        .then((r) => {
          this.total = r.meta.total;
          done(r.data);
        })
        .catch(() => done([]));
    },
    refresh() {
      this.$refs.table?.refresh();
    },
    openAdd() {
      this.isAdd = true;
      this.selected = {};
      this.sidebar = true;
    },
    openEdit(item) {
      this.isAdd = false;
      this.selected = { ...item };
      this.sidebar = true;
    },
    remove(item) {
      this.$swal({
        title: this.$t("messages.delete.title"),
        text: this.$t("messages.delete.body"),
        icon: "warning",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await store.dispatch("hanwha_alarm_rules/delete", item.id);
          this.refresh();
        }
      });
    },
  },
};
</script>
